module.exports = __webpack_public_path__ + "img/rank2.ba993e31.png";